// import external dependencies
import 'jquery';
import 'bootstrap/dist/js/bootstrap';
import 'owl.carousel/dist/owl.carousel.js';
import 'imagesloaded/imagesloaded.js';
import 'jquery-lazyload/jquery.lazyload.js';
import 'isotope-layout/dist/isotope.pkgd.js';

// import local dependencies
import Router from './util/router';
import common from './routes/Common';
import home from './routes/Home';
import aboutUs from './routes/About';
import fuelSaving from './routes/FuelSaving';
import contact from './routes/Contact';
import calculator from './routes/Calculator';
import posts from './routes/Posts';
import designSolutions from './routes/DesignSolutions';
import truckAerodynamics from './routes/TruckAerodynamics';
import careers from './routes/Careers';
import gallery from './routes/Gallery';
import ourStory from './routes/OurStory';

// Use this variable to set up the common and page specific functions. If you
// rename this variable, you will also need to rename the namespace below.
const routes = {
  // All pages
  common,
  // Home page
  home,
  // About us page, note the change from about-us to aboutUs.
  aboutUs,
  fuelSaving,
  contact,
  calculator,
  blog: posts,
  archive: posts,
  singlePost: posts,
  designSolutions,
  truckAerodynamics,
  careers,
  gallery,
  ourStory,
};

// Load Events
document.addEventListener('DOMContentLoaded', () => new Router(routes).loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js